<template>
    <div>
        <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"
            :height="150" :width="150" :color="'#FFFF00'" :background-color="'#000000'" :opacity="0.5">
        </loading>
        <div v-if="!loading">
            <div class="cad-back-bar">
                <v-btn color="warning" style="width:100px;" @click="goBack(details)">
                    {{$t('button.back')}}
                </v-btn>
            </div>
            <div class="cad-scroll-content">
                <app-claim-approval-details
                    v-bind:claimApprovalRecord="this.claimApprovalRecord"
                    v-bind:staffApproveList="this.staffApproveList"
                />
            </div>
        </div>
    </div>
</template>

<script>

import moment from 'moment'
import ClaimApprovalInfo from '../../sscomponents/claimapprovaldetails/ClaimApprovalInfo.vue'
import Loading from "vue-loading-overlay";

export default {

    components: {
        "app-claim-approval-details": ClaimApprovalInfo,
        Loading
    },

    data() {
        return {
            claimApprovalRecord: null,
            leaveClaimInfo: [],
            staffApproveList: [],
            loading: false,
        }
    },

    methods: {
        goBack(info) {
            this.$router.push({name: 'selfserviceclaimapproval', params: { itemfromapprovaldetails: info }});
        },

        loadApprovalInfo(){

            const vm = this;
            vm.loading = true;
            
            this.$store.dispatch('get', {url: "/claimrecord/wftran/" + this.claimApprovalRecord.wftrandid + "/" + 1}) // 1 is for web, 2 is for mobile (temporary fix)
            .then((res) => {
                const result = res.data;
                
                if (result.status === 200) {
                    vm.leaveClaimInfo = result.rec

                    if (vm.leaveClaimInfo.length > 0) {
                        for (var i = 0; i < vm.leaveClaimInfo.length; i++) {
                            if (vm.leaveClaimInfo[i].aprdate) {
                                vm.leaveClaimInfo[i].aprdate = moment(vm.leaveClaimInfo[i].aprdate).format("YYYY-MM-DD HH:mm:ss");
                            }
                        }
                    }
                }

                vm.staffApproveList = vm.leaveClaimInfo.filter(val => val.wfstatus == 'DONE')
                vm.loading = false;

            }).catch((err) => {
                vm.loading = false;
                console.error(err)
            });

        }

    },

    computed: {
        details: function() {
            return this.claimApprovalRecord;
        }
    },

    mounted() {
       this.claimApprovalRecord = this.$route.params.item;
       this.loadApprovalInfo();
    }
}

</script>

<style scoped>
.cad-back-bar {
    padding: 14px 16px 10px 16px;
    border-bottom: 1px solid #F1F5F9;
}
.cad-scroll-content {
    height: calc(100vh - 175px);
    overflow-y: auto;
    padding: 16px;
}
.cad-scroll-content::-webkit-scrollbar { width: 6px; }
.cad-scroll-content::-webkit-scrollbar-track { background: #F8FAFF; }
.cad-scroll-content::-webkit-scrollbar-thumb { background: #C7D2FE; border-radius: 3px; }
</style>